import React, { useEffect, useState } from "react";
import { Checks, Copy, Warning, WarningCircle, X } from "@phosphor-icons/react";
import PromoBreakdown from "../Dashboard/PromoBreakdown";

const DiningModel = ({requestData,setRequestType,setOpenRequestModal,setRequestData}) => {
 
 
    // Close Modal
    const closeModal=()=>{
        try{
            setOpenRequestModal(false);
            setRequestType("");
            setRequestData(null);
            
        }catch(error){
            console.log(error);
        }
    }


 

    return (
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
            <form
                className="popup-content bg-white p-6 rounded-lg shadow-xl text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]"
           
            >
                {/* Header Section */}
                <div className="flex items-center justify-between">
                    <h2 className="text-2xl font-bold text-gray-800">
                        {
                            requestData?.type === "Restaurant Dining" ? "Restaurant Dining" : "In Room Dining"
                        }
                        
                    </h2>
                    <button
                        onClick={()=>closeModal()}
                        className="p-2 border border-gray-300 rounded-md hover:bg-[#F2F7FF] transition duration-150"
                        type="button"
                    >
                        <X weight="bold" size={18} />
                    </button>
                </div>

                <div>

                    {/* Room and Staff Info */}
                    <div className="flex gap-2 flex-col">
                        <h2 className="font-semibold text-gray-700 flex items-center justify-between w-1/2">
                            Room Number
                            <span> 
                             {
                            requestData?.type === "Restaurant Dining" ?(requestData?.room_number || "") : (requestData?.delivery_room || "")
                            }
                            </span>
                        </h2>
                        
                        {
                            requestData?.type === "In Room Dining" && 
                            <div className="font-semibold text-gray-700 flex items-center justify-between w-1/2">
                                <p className=" mb-1">Staff Name</p>
                                <span>{requestData?.staff_member_name || ""}</span>
                            </div>
                        }
                    </div>
                    {
                        requestData?.table_number &&
                        <div className="flex gap-2 flex-col mt-4">
                            <h2 className="font-semibold text-gray-700 flex items-center justify-between w-1/2">
                                Table Number
                                <span> 
                                    {requestData?.table_number || ""}
                                </span>
                            </h2>
                            
                            {
                                requestData?.type === "In Room Dining" && 
                                <div className="font-semibold text-gray-700 flex items-center justify-between w-1/2">
                                    <p className=" mb-1">Staff Name</p>
                                    <span>{requestData?.staff_member_name || ""}</span>
                                </div>
                            }
                        </div>
                    }

                    {/* Items Ordered Table */}
                    <table className="w-full border-collapse text-left mt-2">
                        <thead>
                            <tr className="bg-gray-100 text-gray-700 font-semibold">
                                <th className="p-2">Item</th>
                                <th className="p-2">Price</th>
                                <th className="p-2">Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requestData.food_items && requestData.food_items.map((item, index) => (
                                <tr key={index} className="border-t">
                                    <td className="p-2">{item.name}</td>
                                    <td className="p-2">{item.price}</td>
                                    <td className="p-2">{item.quantity}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>


                    {/* Total Amount */}
                    {requestData?.tax_amount || (requestData?.promotion_id && requestData?.discount_amount) ? (
                        <div className="mt-2">
                            <PromoBreakdown
                                grossAmount={requestData?.total_amount}
                                discountAmount={requestData?.discount_amount}
                                taxAmount={requestData?.tax_amount}
                                promotionId={requestData?.promotion_id}
                            />
                        </div>
                        ) : (
                        <div className="mt-2 font-semibold text-right">
                            Total Amount: {
                            requestData?.food_items && requestData.food_items.length > 0
                                ? requestData.food_items.reduce(
                                    (total, item) => total + (item.price || 0) * (item.quantity || 0),
                                    0
                                )
                                : 0
                            }
                        </div>
                    )}

                    {/* Remarks Section */}
                    <div className="mt-2">
                        <label className="font-semibold text-gray-700">
                            Remarks
                        </label>
                        <textarea
                            rows={4}
                            className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:outline-none focus:border-blue-400"
                            placeholder="Mention your comment here"
                            value={requestData?.remarks || ""}
                            disabled

                        ></textarea>
                    </div>

                    {requestData?.additional_comments &&
                    <div>
                        <p className="flex items-center gap-2 bg-yellow-100 p-1.5 rounded-md text-yellow-700 px-6 text-sm">
                            <Warning size={16} weight="bold" />{" "}
                            {requestData.additional_comments}
                        </p>
                    </div>
                    }
 

 
                </div>
 
            </form>
        </div>
    );
};

export default DiningModel;
